// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1BFgO","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2xv9i"};